import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../../ng2-bootstrap-modal/dialog.service';
import {HostingService} from "../../hosting.service";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {DbServerErrors} from "../../../../../shared/interceptors/db-server-errors";
import { filter, first } from "rxjs";


@Component({
    selector: 'db-upload-csv-dialog',
    templateUrl: './upload-csv-dialog.component.html',
    styleUrls: ['./upload-csv-dialog.component.scss'],
    standalone: false
})
export class UploadCsvDialogComponent extends DialogComponent<null, Boolean> implements OnInit {

  @Input() websiteId: number;
  public changes: any;
  public csvFile: any;
  public loading: boolean;
  public hasServerFieldErrors: boolean;
  public serverErrors: DbServerErrors;
  public isMobile: boolean;

  constructor(
    private _dialogService: DialogService,
    private _hostingService: HostingService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
  }


  public uploadFile(): void {
    if (this.csvFile) {
      this.loading = true;
      this.serverErrors = null;
      this.hasServerFieldErrors = false;

      this._hostingService.uploadCsv( this.websiteId, this.csvFile)
        .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response: DbResponse): void => {
          if (response.success) {
            this.result = true;
            this.cancel();
            if (response.message === "Some rules are not imported") {
              NotifierComponent.notify(new Notification(response.message, NotificationType.SUCCESS, true));
            }
          }
          else {
            this.close();
            NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER, true));
          }
          this.loading = false;
        });
    }

  }

  public onFileSelect($event) {
    if ($event.target.files[0]) {
      this.csvFile = $event.target.files[0];
    }
  }

  public cancel(): void {
    this.result = true;
    this.close();
  }

}
